document.addEventListener("DOMContentLoaded", () => {
  const scrollers = document.querySelectorAll(".scroll_bar");

  if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    scrollers.forEach((scroller) => {
      // Evita duplicaciones si ya fue animado
      if (scroller.dataset.animated === "true") return;

      const scrollerInner = scroller.querySelector(".scroller__inner");
      if (!scrollerInner) return; // Protección por si falta

      const scrollerContent = Array.from(scrollerInner.children);

      scrollerContent.forEach((item) => {
        const duplicatedItem = item.cloneNode(true);
        duplicatedItem.setAttribute("aria-hidden", true);
        scrollerInner.appendChild(duplicatedItem);
      });

      scroller.setAttribute("data-animated", "true");
    });
  }
});
